import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Truck, Shield, Clock, Heart } from 'lucide-react';

const ProductoPage = () => {
  const { categoria } = useParams();
  const navigate = useNavigate();

  const productos = {
    arreglos: {
      nombre: 'Arreglos Florales',
      descripcion: 'Arreglos florales únicos y personalizados para cada ocasión. Diseñados con las flores más frescas de Arequipa.',
      detalles: [
        'Flores premium seleccionadas a mano',
        'Diseños exclusivos y personalizados',
        'Incluye tarjeta de dedicatoria',
        'Entrega express en menos de 3 horas',
        'Garantía de frescura por 7 días'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0a7bf05e-4665-4538-4213-bb1f35ec7100/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/11a81113-34af-4579-ae8e-3c92b29fc100/public'
      ],
      keywords: 'arreglos florales arequipa, flores a domicilio arequipa, florería arequipa'
    },
    boxes: {
      nombre: 'Boxes Florales',
      descripcion: 'Hermosas cajas florales con presentación elegante. Perfectas para regalar en cualquier ocasión especial.',
      detalles: [
        'Cajas decorativas premium',
        'Combinaciones de flores exclusivas',
        'Presentación elegante y sofisticada',
        'Ideal para regalo corporativo',
        'Disponible en varios tamaños'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/85bbe1af-b296-4087-84a8-81845666be00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/63788c41-d490-432a-471c-5e28b52bce00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/574af829-6517-4754-b118-c48940585800/public'
      ],
      keywords: 'boxes florales arequipa, cajas de flores arequipa, flores en caja arequipa'
    },
    ramos: {
      nombre: 'Ramos de Flores',
      descripcion: 'Ramos frescos y hermosos para toda ocasión. Elaborados con las mejores flores de la temporada.',
      detalles: [
        'Flores de temporada más frescas',
        'Ramos clásicos y modernos',
        'Tamaños pequeño, mediano y grande',
        'Envueltos con papel decorativo',
        'Perfectos para cualquier celebración'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/087f35d1-48ca-4540-4281-08990078ee00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1b3f2bee-4ce7-4d47-3dde-5b19fa066d00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b9361911-d3d6-4c92-0e75-04667c70e300/publicContain'
      ],
      keywords: 'ramos de flores arequipa, comprar flores arequipa, florería delivery arequipa'
    },
    rosas: {
      nombre: 'Rosas Rojas y de Colores',
      descripcion: 'Ramos de rosas rojas, rosadas, blancas y amarillas. Frescas y hermosas para expresar amor y cariño.',
      detalles: [
        'Rosas premium importadas',
        'Variedad de colores disponibles',
        'Ramos desde 12 hasta 100 rosas',
        'Empaque elegante incluido',
        'Perfectas para expresar amor'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/3c289914-6f7b-48bf-5f2f-456ab5303900/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5f3f5c35-2c59-465d-4e09-c0cf93eee600/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/33cd1368-94c3-4419-816b-25a0665aad00/public'
      ],
      keywords: 'rosas rojas arequipa, ramo de rosas arequipa, rosas para regalar arequipa, flores románticas arequipa'
    },
    lirios: {
      nombre: 'Lirios Frescos',
      descripcion: 'Lirios elegantes y aromáticos en diferentes colores. Perfectos para ocasiones especiales y decoración.',
      detalles: [
        'Lirios importados de alta calidad',
        'Colores: blancos, rosados, amarillos',
        'Aroma natural delicado',
        'Duración prolongada',
        'Ideales para eventos elegantes'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8728d7bc-6b77-49b4-7bbe-77f98df9f300/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0c6ec651-4d5b-41a1-7023-7d76371fd400/public'
      ],
      keywords: 'lirios arequipa, lirios frescos arequipa, flores lirios arequipa, arreglos con lirios arequipa'
    },
    girasoles: {
      nombre: 'Girasoles Alegres',
      descripcion: 'Girasoles frescos y radiantes. Símbolo de alegría, amistad y energía positiva.',
      detalles: [
        'Girasoles de temporada frescos',
        'Tamaño grande y vibrante',
        'Perfectos para alegrar el día',
        'Ideales para amistad',
        'Arreglos alegres y coloridos'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/54aef800-701d-4185-5244-1ad2e1980900/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cd309af2-66cc-4721-cc51-72039ea2ab00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain'
      ],
      keywords: 'girasoles arequipa, flores amarillas arequipa, girasoles frescos arequipa, flores para amistad arequipa'
    },
    tulipanes: {
      nombre: 'Tulipanes Importados',
      descripcion: 'Tulipanes holandeses de colores vibrantes. Elegancia y sofisticación para ocasiones especiales.',
      detalles: [
        'Tulipanes importados premium',
        'Variedad de colores disponibles',
        'Frescura garantizada',
        'Perfectos para primavera',
        'Arreglos exclusivos y elegantes'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a05fc3c6-28c6-47f3-8d07-3eb725c33800/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain'
      ],
      keywords: 'tulipanes arequipa, tulipanes importados arequipa, flores tulipanes arequipa, tulipanes frescos arequipa'
    },
    peluches: {
      nombre: 'Peluches y Flores',
      descripcion: 'Combina flores frescas con tiernos peluches. El regalo perfecto para expresar cariño y amor.',
      detalles: [
        'Peluches de alta calidad',
        'Combinación perfecta con flores',
        'Variedad de tamaños disponibles',
        'Ideal para cumpleaños y aniversarios',
        'Empaque especial de regalo'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/080fe01b-7b1a-47fc-e3ff-719967432100/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c4231067-2088-4e05-9bb4-95b94866a900/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/71dd0f3e-e4c9-4b3c-f2af-cf3fa2fd6e00/public'
      ],
      keywords: 'peluches con flores arequipa, regalos arequipa, flores y peluches arequipa'
    },
    eventos: {
      nombre: 'Flores para Eventos',
      descripcion: 'Decoración floral profesional para tus eventos especiales. Bodas, fiestas corporativas y más.',
      detalles: [
        'Servicio de decoración completa',
        'Asesoría personalizada',
        'Flores para bodas y eventos',
        'Arreglos de mesa y centros',
        'Coordinación completa del evento'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2d4938a6-6347-4c70-6431-f5ef464fb800/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9cf758b5-1b09-4aa3-8509-8409265eb800/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8677e45a-1fa6-4768-9b4f-f01072370800/publicContain'
      ],
      keywords: 'decoración floral eventos arequipa, flores para bodas arequipa, florería para eventos arequipa'
    },
    detalles: {
      nombre: 'Detalles Especiales',
      descripcion: 'Pequeños detalles que hacen grandes momentos. Arreglos florales perfectos para sorprender.',
      detalles: [
        'Detalles personalizados',
        'Tamaño perfecto para regalar',
        'Ideal para fechas especiales',
        'Incluye mensaje personalizado',
        'Presentación cuidada'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f3a481d2-b9de-472b-98c2-8ba5f68d7200/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/655ba3d7-3387-4364-915c-064090bb3700/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d3647739-a971-4494-5dbf-4f53bf55e400/public'
      ],
      keywords: 'detalles florales arequipa, regalos pequeños arequipa, flores para regalar arequipa'
    }
  };

  const producto = productos[categoria] || productos.arreglos;

  const handleWhatsApp = () => {
    const mensaje = `Hola, me interesa ${producto.nombre}. ¿Podrían darme más información?`;
    window.open(`https://wa.me/51959389799?text=${encodeURIComponent(mensaje)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-pink-50 pt-16 md:pt-20">
      {/* Breadcrumb */}
      <div className="bg-white py-4 px-4 border-b">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-sm">
            <button onClick={() => navigate('/')} className="text-pink-600 hover:text-pink-700">Inicio</button>
            <span className="text-gray-400">/</span>
            <button onClick={() => navigate('/catalogos')} className="text-pink-600 hover:text-pink-700">Catálogos</button>
            <span className="text-gray-400">/</span>
            <span className="text-gray-700">{producto.nombre}</span>
          </div>
        </div>
      </div>

      {/* Product Detail */}
      <section className="py-12 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            {/* Images */}
            <div>
              <div className="bg-white rounded-2xl overflow-hidden shadow-xl mb-4">
                <img 
                  src={producto.imagenes[0]}
                  alt={`${producto.nombre} en Arequipa - TQM Florería`}
                  className="w-full aspect-square object-cover"
                />
              </div>
              <div className="grid grid-cols-3 gap-4">
                {producto.imagenes.slice(1).map((img, idx) => (
                  <div key={idx} className="bg-white rounded-xl overflow-hidden shadow-lg">
                    <img 
                      src={img}
                      alt={`${producto.nombre} variación ${idx + 1} - Florería Arequipa`}
                      className="w-full aspect-square object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Info */}
            <div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-pink-900 mb-4">
                {producto.nombre}
              </h1>
              <p className="text-base md:text-lg text-gray-700 mb-8">{producto.descripcion}</p>

              {/* Features */}
              <div className="bg-pink-50 rounded-xl p-6 mb-8">
                <h2 className="text-xl font-bold text-pink-900 mb-4">Características:</h2>
                <ul className="space-y-3">
                  {producto.detalles.map((detalle, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-gray-700">
                      <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-0.5" />
                      <span>{detalle}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Benefits */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow">
                  <Truck className="w-8 h-8 text-pink-600" />
                  <div>
                    <p className="font-semibold text-sm">Delivery Express</p>
                    <p className="text-xs text-gray-600">Menos de 3 horas</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow">
                  <Shield className="w-8 h-8 text-pink-600" />
                  <div>
                    <p className="font-semibold text-sm">Garantía</p>
                    <p className="text-xs text-gray-600">100% frescura</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow">
                  <Clock className="w-8 h-8 text-pink-600" />
                  <div>
                    <p className="font-semibold text-sm">Disponible</p>
                    <p className="text-xs text-gray-600">Lun-Sáb 8AM-9PM</p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <Button
                onClick={handleWhatsApp}
                className="w-full bg-green-500 hover:bg-green-600 text-white py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 font-bold"
              >
                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                Hacer mi Pedido por WhatsApp
              </Button>
              
              <p className="text-center text-sm text-gray-600 mt-4">
                Respuesta inmediata • Asesoría personalizada
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-12 md:py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-pink-900 mb-8 text-center">
            Otros Productos que te pueden Interesar
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {Object.entries(productos)
              .filter(([key]) => key !== categoria)
              .slice(0, 4)
              .map(([key, prod]) => (
                <div
                  key={key}
                  onClick={() => {
                    navigate(`/producto/${key}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="bg-pink-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
                >
                  <img 
                    src={prod.imagenes[0]}
                    alt={`${prod.nombre} - Florería Arequipa`}
                    className="w-full aspect-square object-cover"
                  />
                  <div className="p-4">
                    <h3 className="font-bold text-pink-900 mb-1">{prod.nombre}</h3>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductoPage;